import {outter_post} from 'common/js/axios-helper';
import {EmptyApi} from "./constant/UrlMapper";


const host = '8891'
const host2 = '8890'


const getChaseListDetail = (data) => {
    return outter_post(EmptyApi.GetChaseListDetail, data, host);
};

const helpAdd = (data) => {
    return outter_post(EmptyApi.HelpAdd, data, host);
};
export default { getChaseListDetail, helpAdd}



// WEBPACK FOOTER //
// ./src/service/EmptyService.js